import { Poppins, Quicksand } from 'next/font/google';
import Link from 'next/link';
import React from 'react'
const quickSand = Quicksand({weight:"500",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
export default function EnrollnowBox({bgimg,heading4}) {
  return (
   <>
   <section className='pdt50 mpdt20'>

<div className='container'>

<div  style={{background:`url("${bgimg}")`,backgroundPosition: 'center', backgroundSize: 'cover'}}   className='bg-img df fac fjc'>

<div className=''>
    
    <h4 className={`fs-33 tac con-800 cw pdt100 mfs-24 ${extraPopins.className}`}>{heading4}</h4>

<div className='pdt24 df fac fjc'>
  <button className={`btn fs-19 ${popins.className}`}> <Link href={"/contact"} className='cw'> Enroll now </Link> </button>
</div>

</div>

</div>

</div>


   </section>
   
 <style jsx>

{`
.bg-img{
  
    width: 100%;
    height:446px;
    border-radius: 32px;
    background-repeat:no-repeat;
    background-size: cover;
    background-position: center;

}
.con-800{
    max-width:878px;
    width:100%;
    height:100%;
    margin:0 auto;
}
.btn{
    width:162px;
    height:55px;
    border-radius:8px;
    background-color: #FFA900;
    color: #090909;
    cursor: pointer;
     transition: color 0.3s ease-out;

}
.btn:hover {
    color: #ffffff;
  }
  @media only screen and (max-width: 1023px){
    .con-800{
        width:100%;
        height:100%;
        margin:0 auto;
    }
  }
`}    
    
</style>  
   
   </>
  )
}
